import {gql} from '@apollo/client'

export const WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_UPDATE = gql`
  mutation wineClubSubscriptionCustomerPackagePaymentUpdate(
    $membership: WineClubSubscriptionCustomerPackagePaymentUpdateInput!
  ) {
    wineClubSubscriptionCustomerPackagePaymentUpdate(input: $membership) {
      clientMutationId
    }
  }
`

export const UPDATE_WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_MANY = gql`
  mutation updateWineClubSubscriptionPaymentMethodMany(
    $input: UpdateWineClubSubscriptionPaymentMethodManyInput!
  ) {
    updateWineClubSubscriptionPaymentMethodMany(input: $input) {
      clientMutationId
    }
  }
`

export const WINE_CLUB_SUBSCRIPTION_SHIPPING_ADDRESS_UPDATE = gql`
  mutation wineClubSubscriptionCustomerPackageAddressUpdate(
    $membership: WineClubSubscriptionCustomerPackageAddressUpdateInput!
  ) {
    wineClubSubscriptionCustomerPackageAddressUpdate(input: $membership) {
      clientMutationId
    }
  }
`
export const WINE_CLUB_SUBSCRIPTION_BILLING_ADDRESS_UPDATE = gql`
  mutation wineClubSubscriptionCustomerPackageAddressUpdate(
    $membership: WineClubSubscriptionCustomerPackageBillingAddressUpdateInput!
  ) {
    wineClubSubscriptionCustomerPackageBillingAddressUpdate(input: $membership) {
      clientMutationId
    }
  }
`
